import * as React from "react";
import { NameWrapper, OneLineName, ActiveImg, TwoLineName } from "./styled";
export const NameView = (props) => {
    const { activeImg, name } = props;
    return (React.createElement(NameWrapper, null, activeImg ? (React.createElement(React.Fragment, null,
        React.createElement(OneLineName, null, name),
        React.createElement(ActiveImg, { src: activeImg }))) : (React.createElement(TwoLineName, null, name))));
};
